import { useEffect, useState } from "react";
import { Button } from "../../../components/button/button";
import { Graph } from "../../../components/graph/graph";
import { Header } from "../../../components/header/header";
import { useSelector } from "react-redux";
import { IncomeFormulaItem } from "../../../components/incomeFormulaItem/incomeFormulaItem";
import IncomeAPI from "../../../api/IncomeAPI";

import { Text } from "../../../components/text/text";

import styles from "./incomePage.module.css"

const initialIncomeFormulaData = {
    plan: {
        goal: 0,
        current: 0,
    },
    motivation: {
        avgRevenue: 0,
        baseSalary: 0,
        alreadyEarned: 0,
    },
    currentAvgRevenue: 0,
    totalCurrentSalary: 0,
}

export const IncomePage = () => {
    const [countDays, setCountDays] = useState(30);
    const [incomeFormulaData, setIncomeFormulaData] = useState(initialIncomeFormulaData);
    const [averageDaily, setAverageDaily] = useState(0);
    const [graph, setGraph] = useState([]);

    const cafeId = useSelector(state => state.user.userData?.cafeId);

    useEffect(() => {
        if (!cafeId) return;
        IncomeAPI
            .fetchInfoPlan(cafeId, countDays)
            .then(res => setIncomeFormulaData(res))
            .catch(console.error);
    }, [cafeId, countDays]);

    useEffect(() => {
        if (!cafeId) return;
        IncomeAPI
            .fetchPlot(cafeId)
            .then(res => setGraph(res))
            .catch(console.error);
    }, [cafeId]);

    useEffect(() => {
        if (!cafeId) return;
        IncomeAPI
            .fetchAverageDaily(cafeId)
            .then(res => setAverageDaily(res))
            .catch(console.error);
    }, [cafeId]);

    const avgRevenue = incomeFormulaData.motivation.avgRevenue;
    const curAvgRevenue = incomeFormulaData.currentAvgRevenue;

    return (
        <>
            <Header title="Доход" />

            <div className={styles.income_formula_container}>
                <Text as="div" variant="h3" className={styles.income_formula_title} >Формула дохода</Text>

                <div className={styles.income_formula_periods}>
                    {/* <Button view="thin" text="День" type={countDays === 1 ? "primary" : "hint"} onClick={() => setCountDays(2)} /> */}
                    <Button view="thin" text="Неделя" type={countDays === 7 ? "primary" : "hint"} onClick={() => setCountDays(7)} />
                    <Button view="thin" text="Месяц" type={countDays === 30 ? "primary" : "hint"} onClick={() => setCountDays(30)} />
                </div>

                <div style={{ display: "grid", gap: "10px 6px", gridTemplateColumns: "1fr 1fr" }}>
                    <IncomeFormulaItem title="План по выручке" value={incomeFormulaData.plan.goal} />
                    <IncomeFormulaItem title="Текущая выручка" value={incomeFormulaData.plan.current} />
                    <IncomeFormulaItem title="План ср. чек" value={incomeFormulaData.motivation.avgRevenue} />
                    <IncomeFormulaItem
                        title="Текущий ср. чек"
                        value={incomeFormulaData.currentAvgRevenue}
                        type={(curAvgRevenue < avgRevenue * 0.95) ? "low" : (curAvgRevenue > avgRevenue * 1.05) ? "high" : "mean"}
                    />
                    <IncomeFormulaItem title="Оклад" value={incomeFormulaData.motivation.baseSalary} />
                    <IncomeFormulaItem title="Текущий доход" value={incomeFormulaData.motivation.alreadyEarned} />
                </div>

                <IncomeFormulaItem big title="Зарплата" value={incomeFormulaData.totalCurrentSalary} />
            </div>

            <Graph
                items={graph}
                height="223px"
                title="График изменения выручки"
            />

            <div style={{ display: "grid", gap: "6px", gridTemplateColumns: "1fr 1fr 1fr" }}>
                <IncomeFormulaItem title="День" value={averageDaily} />
                <IncomeFormulaItem title="Неделя" value={averageDaily * 7} />
                <IncomeFormulaItem title="Месяц" value={averageDaily * 30} />
            </div>
        </>
    );
}
